// dev
// export const API_BASE = "http://192.168.1.12:5055/api";
export const API_BASE = "https://portal-api.openpesa.net/api";

export const FILE_BASE = API_BASE;

/* ------ AUTHENTICATION ------- */
export const LOGIN_URL = "/auth/login";
export const OTP_URL = "/auth/verify-otp";
export const FORGET_PASSWORD_URL = "/auth/reset-password";
export const CHANGE_PASSWORD_URL = "/partner-resource/change-password";

/* ------- OTHER RESOURCES ------- */
export const DASHBOARD_URL = "/partner-resource/dashboard";
export const TRANSACTIONS_URL = "/partner-resource/view-transactions";
export const NOTIFICATIONS_URL = "/partner-resource/notifications";
export const LOGS_URL = "/partner-resource/user-activity-logs";

/* ------- PARTNER STAFF END POINTS ------- */
export const STAFF_LIST_URL = "/partner-resource/get-users-for-partner";
export const ADD_STAFF_URL = "/partner-resource/register-partner-user";
export const VIEW_STAFF_URL = "/partner-resource/get-one-partner-user";
export const EDIT_STAFF_URL = "/partner-resource/edit-partner-user";
export const ACTIVATE_STAFF_URL = "/partner-resource/activate-partner-user";
export const DEACTIVATE_STAFF_URL = "/partner-resource/deactivate-partner-user";
export const APPROVE_STAFF_URL = "/partner-resource/approve-partner-user";
export const REJECT_STAFF_URL = "/partner-resource/reject-partner-user";
export const RESET_STAFF_PASSWORD_URL =
  "/partner-resource/admin-reset-password";
export const UNBLOCK_STAFF_URL = "/partner-resource/unlock-user";

/* ------- PARTNER END POINTS ------- */
export const PARTNER_LIST_URL = "/partner-resource/get-partners";
export const ADD_PARTNER_URL = "/partner-resource/register-partner";
export const VIEW_PARTNER_URL = "/partner-resource/get-one-partner";
export const EDIT_PARTNER_URL = "/partner-resource/edit-partner";
export const ACTIVATE_PARTNER_URL = "/partner-resource/activate-partner";
export const DEACTIVATE_PARTNER_URL = "/partner-resource/deactivate-partner";
export const APPROVE_PARTNER_URL = "/partner-resource/approve-partner";
export const REJECT_PARTNER_URL = "/partner-resource/reject-partner";
export const GET_ACTIVE_PARTNERS = "/partner-resource/get-active-partners";
export const GET_LOGGED_IN_PARTNER_DETAILS =
  "/partner-resource/get-logged-in-partner-details";
export const UPLOAD_PARTNER_PHOTO = "/partner-resource/upload-partner-photo";
export const GET_PARTNER_AGENTS = "/partner-resource/get-partner-agents";

/* ------- AGENT END POINTS ------- */
export const AGENT_LIST_URL = "/wakala-resource/get-all-wakala";
export const ADD_AGENT_URL = "/wakala-resource/register-wakala";
export const VIEW_AGENT_URL = "/wakala-resource/get-one-wakala";
export const EDIT_AGENT_URL = "/wakala-resource/edit-wakala";
export const ACTIVATE_AGENT_URL = "/wakala-resource/activate-wakala";
export const DEACTIVATE_AGENT_URL = "/wakala-resource/deactivate-wakala";
export const APPROVE_AGENT_URL = "/wakala-resource/approve-wakala";
export const REJECT_AGENT_URL = "/wakala-resource/reject-wakala";
export const AGENT_COMMISSION_SUMMARY_URL =
  "/wakala-resource/get-agent-commission-summary";
export const AGENT_COMMISSIONS_URL = "/wakala-resource/get-agent-commissions";
export const AGENT_COMMISSIONS_BY_DATE_URL =
  "/wakala-resource/get-agent-commissions-by-date";

/* ------- AGENT STAFF END POINTS ------- */
export const AGENT_STAFF_LIST_URL = "/wakala-resource/get-users-for-wakala";
export const ADD_AGENT_STAFF_URL = "/wakala-resource/register-wakala-user";
export const VIEW_AGENT_STAFF_URL = "/wakala-resource/get-one-wakala-user";
export const EDIT_AGENT_STAFF_URL = "/wakala-resource/edit-wakala-user";
export const ACTIVATE_AGENT_STAFF_URL = "/wakala-resource/activate-wakala-user";
export const DEACTIVATE_AGENT_STAFF_URL =
  "/wakala-resource/deactivate-wakala-user";
export const APPROVE_AGENT_STAFF_URL = "/wakala-resource/approve-wakala-user";
export const REJECT_AGENT_STAFF_URL = "/wakala-resource/reject-wakala-user";
export const RESET_AGENT_PASSWORD_URL =
  "/partner-resource/admin-reset-password";
export const UNBLOCK_AGENT_URL = "/partner-resource/unlock-user";
export const GET_AGENT_DETAILS = "/wakala-resource/get-agent-details";

/* ------- ACCOUNT END POINTS ------- */
export const ACCOUNT_LIST_URL = "/wakala-resource/get-all-accounts";
export const CREATE_ACCOUNT_URL = "/wakala-resource/create-wakala-account";
export const VIEW_ACCOUNT_URL = "/wakala-resource/get-one-agent-account";
export const ACTIVATE_ACCOUNT_URL = "/wakala-resource/activate-account";
export const DEACTIVATE_ACCOUNT_URL = "/wakala-resource/deactivate-account";
export const APPROVE_ACCOUNT_URL = "/wakala-resource/approve-account";
export const REJECT_ACCOUNT_URL = "/wakala-resource/reject-account";
export const VIEW_AGENT_ACCOUNT_URL = "/wakala-resource/get-wakala-accounts";
export const GET_WAKALA_ACCOUNT_DETAILS_URL =
  "/wakala-resource/get-wakala-account-details";

/* -------- API DETAILS--------- */
export const API_LIST_URL = "/partner-resource/get-all-partner-api-detail";
export const VIEW_API_URL = "/partner-resource/get-one-api-detail";
export const API_DETAILS_URL =
  "/partner-resource/get-logged-in-partner-api-details";
export const APPROVE_API_URL = "/partner-resource/approve-api-detail";
export const REJECT_API_URL = "/partner-resource/reject-api-detail";
export const ACTIVATE_API_URL = "/partner-resource/activate-api-detail";
export const DEACTIVATE_API_URL = "/partner-resource/deactivate-api-detail";
export const GET_PARTNER_PROPERTIES =
  "/partner-resource/get-partner-properties";
export const CREATE_PARTNER_PROPERTY =
  "/partner-resource/create-partner-property";
export const UPDATE_PARTNER_PROPERTY =
  "/partner-resource/update-partner-property";
export const UPDATE_FSP_CODE = "/partner-resource/update-fsp-code";
export const UPDATE_OUTBOUND_CREDENTIALS =
  "/partner-resource/update-outbound-credentials";
export const DOWNLOAD_KEY = "/partner-resource/download-key";

/* ------- MERCHANT END POINTS ------- */
export const MERCHANT_LIST_URL = "/merchant-resource/list-merchants";
export const VIEW_MERCHANT_URL = "/merchant-resource/get-one-merchant";
export const ACTIVATE_MERCHANT_URL = "/merchant-resource/activate-merchant";
export const DEACTIVATE_MERCHANT_URL = "/merchant-resource/deactivate-merchant";
export const ADD_MERCHANT_URL = "/merchant-resource/create-merchant";
export const CREATE_MERCHANT_ACCOUNT_URL =
  "/merchant-resource/create-merchant-account";
export const UPDATE_MERCHANT_ACCOUNT_URL =
  "/merchant-resource/update-merchant-account";
export const GET_MERCHANT_TRANSACTIONS_URL =
  "/merchant-resource/get-merchant-transactions";
export const GET_ONE_MERCHANT_TRANSACTION_URL =
  "/merchant-resource/get-one-merchant-transaction";
export const GET_MERCHANT_PROPERTIES_URL =
  "/merchant-resource/get-merchant-properties";
export const CREATE_MERCHANT_PROPERTY_URL =
  "/merchant-resource/create-merchant-property";
export const UPDATE_MERCHANT_PROPERTY_URL =
  "/merchant-resource/update-merchant-property";
export const DELETE_MERCHANT_PROPERTY_URL =
  "/merchant-resource/delete-merchant-property";

/* -------- LOGS --------- */
export const LIST_LOGS = "/admin/list-logs-folders";
export const VIEW_LOG = "/admin/read-log-file";
export const LIST_FOLDER_LOGS = "/admin/list-log-files";

/* -------- TARRIF --------- */
export const LIST_TARRIF_URL = "/tarrif-resource/list-tarrifs";
export const CREATE_TARRIF_URL = "/tarrif-resource/create-tarrif";
export const UPDATE_TARRIF_URL = "/tarrif-resource/update-tarrif";
export const DELETE_TARRIF_URL = "/tarrif-resource/delete-tarrif";
